import React from "react";
import { COLORS } from "./constants"; // Import COLORS if you want to use the brand blue

const MapStyles = () => (
  <style>
    {`
      /* 1. NATURAL MAP COLORS */
      .maplibregl-canvas {
        outline: none;
      }

      /* 2. PULSE ANIMATION FOR USER LOCATION */
      .pulse-container {
        position: relative;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none; /* Let clicks pass through to the map */
      }

      /* The solid center dot */
      .center-dot {
        width: 14px;
        height: 14px;
        background-color: #00bbd4; /* COLORS.primary */
        border: 3px solid #fff;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
        z-index: 2;
      }

      /* The rippling rings */
      .pulse-ring {
        position: absolute;
        top: 50%; left: 50%;
        border-radius: 50%;
        background-color: rgba(0, 187, 212, 0.4); /* COLORS.primary with opacity */
        transform: translate(-50%, -50%);
        animation: pulseRing 2.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
        z-index: 1;
      }

      .pulse-ring-1 { width: 30px; height: 30px; animation-delay: 0s; }
      .pulse-ring-2 { width: 60px; height: 60px; animation-delay: 0.8s; }
      
      @keyframes pulseRing {
        0% { opacity: 0.8; transform: translate(-50%, -50%) scale(0.3); }
        80% { opacity: 0; transform: translate(-50%, -50%) scale(1.5); }
        100% { opacity: 0; transform: translate(-50%, -50%) scale(1.5); }
      }

      /* 3. REFINED POPUP STYLING */
      .maplibregl-popup { z-index: 1000; }
      .maplibregl-popup-content {
        padding: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 16px !important;
      }
      .maplibregl-popup-tip {
        border-top-color: #fff !important;
        margin-bottom: -1px; 
      }
      .maplibregl-popup-close-button { display: none; }
    `}
  </style>
);

export default MapStyles;